module.exports = __webpack_public_path__ + "static/media/6.fed18905.svg";